export const getAttributeValueFor = (item: any, attributeIdentifier: string) => {
  return item?.attributes?.filter(({ identifier }) => identifier === attributeIdentifier)[0]?.value || null;
};
